import React from 'react';
import { PropInfo, CodeExample, ReactTablev6Props } from '@cimpress/react-components';

import TableCode from '!raw-loader!./table.jsx';
import TableDemo from './table.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const TableDocs = () => {
  const propInfos: PropInfo<ReactTablev6Props>[] = [
    {
      name: 'condensed',
      type: 'boolean',
      default: '',
      description: 'Toggles the condensed styling for the table.',
    },
    {
      name: 'selectable',
      type: 'boolean',
      default: '',
      description: 'Toggles the column of checkboxes that make rows selectable.',
    },
    {
      name: 'keyField',
      type: 'string',
      default: '_id',
      description: 'The unique accessor property in order to render the select field for a particular row.',
    },
    {
      name: 'goToLabelText',
      type: 'string',
      default: '',
      description: "Text to display in the component that allows jumping to specific text. Default: 'Go To'",
    },
    {
      name: 'perPageLabelText',
      type: 'string',
      default: '',
      description: "Text to display for the dropdown controlling page size. Default: 'Per Page'",
    },
  ];

  return (
    <ComponentDoc
      name="Table"
      propInfos={propInfos}
      remarks={
        <p>
          All other props not enumerated here will be passed to the underlying component -- see the{' '}
          <a href="https://github.com/react-tools/react-table" target="_blank" rel="noopener noreferrer">
            react-table docs
          </a>{' '}
          to see more options.
        </p>
      }
    >
      <TableDemo />
      <CodeExample code={TableCode} />
    </ComponentDoc>
  );
};

export default TableDocs;
